import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    SET_SUMMARY_REPORT_ID: createActionType(FULL_NAMESPACE, "SET_SUMMARY_REPORT_ID"),
    SET_NEW_SUMMARY_REPORT: createActionType(FULL_NAMESPACE, "SET_NEW_SUMMARY_REPORT"),
    SET_DRAFT: createActionType(FULL_NAMESPACE, "SET_DRAFT"),
    GET_SUMMARY_REPORT: createActionType(FULL_NAMESPACE, "GET_SUMMARY_REPORT"),
    GET_SUMMARY_REPORT_COMPLETED: createActionType(FULL_NAMESPACE, "GET_SUMMARY_REPORT_COMPLETED"),
    SAVE_SUMMARY_REPORT: createActionType(FULL_NAMESPACE, "SAVE_SUMMARY_REPORT"),
    SAVE_SUMMARY_REPORT_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_SUMMARY_REPORT_COMPLETED")
};
